<template>
  <div
    v-if="show"
    class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
  >
    <div class="bg-white p-6 rounded-lg shadow-lg w-96">
      <h3 class="text-lg font-semibold mb-4">{{ title }}</h3>
      <p class="text-gray-700 mb-2">{{ warningText }}</p>
      <p class="text-gray-700 mb-4">{{ message }}</p>
      <div class="flex justify-end gap-4">
        <button
          @click="$emit('cancel')"
          class="px-4 py-2 text-gray-600 border rounded-md hover:bg-gray-200"
        >
          Cancel
        </button>
        <button
          @click="$emit('confirm')"
          :disabled="showLoader"
          class="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
        >
          <span v-if="showLoader" class="flex items-center justify-center">
            <img :src="loaderUrl" alt="Confirming..." class="w-6 h-6" />
          </span>
          <span v-else> Confirm </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import loaderUrl from "@/assets/images/loader.gif";

export default {
  props: {
    show: Boolean,
    showLoader: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Are you sure?",
    },
    message: {
      type: String,
      default:
        "Do you really want to delete this item? This action cannot be undone.",
    },
    warningText: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      loaderUrl: loaderUrl,
    };
  },
};
</script>
